import { render, staticRenderFns } from "./WrTable.vue?vue&type=template&id=3f40f548"
import script from "./WrTable.vue?vue&type=script&lang=ts"
export * from "./WrTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports